import { CSSProperties } from 'react';

export const containerStyle: CSSProperties = {
  marginTop: 40,
};

export const headerContainerStyle: CSSProperties = {
  marginBottom: 16,
};

export const titleStyle: CSSProperties = {
  margin: 0,
};

export const subtitleStyle: CSSProperties = {
  fontSize: 13,
};

export const amostraAvalindoStyle: CSSProperties = {
  color: '#1890ff',
};

export const amostraDefaultStyle: CSSProperties = {
  color: '#000',
};

export const areaCellStyle: CSSProperties = {
  textAlign: 'center',
  fontWeight: 500,
};

export const valorCellStyle: CSSProperties = {
  textAlign: 'right',
  fontWeight: 500,
};

export const valorM2CellStyle: CSSProperties = {
  textAlign: 'right',
  fontWeight: 500,
  color: '#666',
};

export const fatCellStyle: CSSProperties = {
  textAlign: 'center',
  fontWeight: 500,
  color: '#1890ff',
};

export const valorHomogCellStyle: CSSProperties = {
  textAlign: 'right',
  fontWeight: 600,
  color: '#52c41a',
  fontSize: 14,
};

export const mediaContainerStyle: CSSProperties = {
  paddingTop: 16,
};

export const mediaSubtitleStyle: CSSProperties = {
  fontSize: 13,
};

export const mediaValueStyle: CSSProperties = {
  fontSize: 20,
  color: '#1890ff',
};

export const inputNumberStyle: CSSProperties = {
  width: '100%',
};

export const rowAvalindoCss = `
  .row-avaliando {
    background-color: #e6f7ff !important;
  }
  .row-avaliando:hover {
    background-color: #bae7ff !important;
  }
`;

export const tableStyles = `
  .ant-table-cell {
    padding: 8px 12px !important;
  }
  .row-avaliando {
    background-color: #e6f7ff !important;
  }
  .row-avaliando:hover {
    background-color: #bae7ff !important;
  }
  .row-fora-intervalo {
    background-color: #fff1f0 !important;
    border-left: 3px solid #ff4d4f !important;
  }
  .row-fora-intervalo:hover {
    background-color: #ffccc7 !important;
  }
  .row-fora-intervalo td {
    color: #cf1322 !important;
  }
`;
